import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import SharedPopUp from "@componentsShared/SharedPopUp/SharedPopUp";
import stl from "@/pages/checkout/finance-checkout/FreeFinanceFormPage.module.css";
import useIsMobile from "@hooks/useIsMobile";
var TabbyCancelPopup = function TabbyCancelPopup(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(["web_tracking", "web_checkout_finance"]),
    t = _useTranslation.t;
  var Mobile = useIsMobile();
  return /*#__PURE__*/React.createElement(SharedPopUp, {
    show: show,
    onClose: onClose,
    widthVariant: Mobile ? "wide" : "narrow"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.freeFinanceCancelOreder
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.freeFinanceCancelIcon
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-center"
  }, t("sure_cancel_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center"
  }, t("information_saved_need_refill_data", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "blueBtn",
    onClick: onConfirm
  }, t("continue_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "whtBtn",
    onClick: onCancel
  }, t("cancel_submitting_application", {
    ns: "web_tracking"
  }))));
};
export default TabbyCancelPopup;